import { pgEnum } from 'drizzle-orm/pg-core'

// Shared by cash_events and cash_flow_rules. They live apart from either table
// so the two modules can reference each other's rows without an import cycle.
export const cashDirectionEnum = pgEnum('cash_direction', [
  'in',
  'out',
  'transfer',
])

// actual: observed on the bank. committed: a voucher with a due date (invoice,
// loan schedule). expected: known future events not yet invoiced (roster payroll,
// contracts, calendar work). forecast: derived from targets and headcount plans.
export const cashCertaintyEnum = pgEnum('cash_certainty', [
  'actual',
  'committed',
  'expected',
  'forecast',
])
